import React from 'react'

import PropTypes from 'prop-types'

import { ERROR_MESSAGES } from '../initialize/initializeErrorMessage'

const ErrorFallback = ({ error }) => {
  const errorMessage = error?.message || ERROR_MESSAGES.UNKNOWN_ERROR

  return (
    <div className="error-container">
      <h2>오류가 발생했습니다</h2>
      <p>{errorMessage}</p>
      <p className="error-retry">{ERROR_MESSAGES.TRY_AGAIN}</p>
      {process.env.NODE_ENV === 'development' && <pre className="error-stack">{error?.stack}</pre>}
    </div>
  )
}

ErrorFallback.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
    stack: PropTypes.string
  })
}

ErrorFallback.defaultProps = {
  error: null
}

export default ErrorFallback
